import calc from '../../../utils/calc'
import buildRankingsHook, { rankingsConfigs } from '../utils/buildRankingsHook'

export const bibibopRankingsConfigs = { ...rankingsConfigs }

const useBibibopRankings = buildRankingsHook({
  metriceCodeMapping: {
    netSalesYoyVariance: ['net_sales', { key: 'net_sales', type: 'yoy' }],
    netSalesYoyPercent: ['net_sales', { key: 'net_sales', type: 'yoy' }],
  },
  handler: (data) => ({
    ...data,
    netSalesYoyVariance: calc(data.netSales, '-', data.yoyNetSales),
    netSalesYoyPercent: calc(
      data.netSales,
      'variancePercentageOf',
      data.yoyNetSales,
    ),
    discount: calc(0, '-', data.discount),
  }),
})

export default useBibibopRankings
